import { h } from 'preact';
import { useState } from 'preact/hooks';
import ToggleButton from 'react-toggle-button';

import SliderInput from '../sliderInput';
import ColorInput from '../colorInput';
import PasteColors from './pasteColors';

import sliderConfigs from './sliderConfigs';
import Radio from '../radioButton';

import style from './style.css';


const Controls = ({
  sliderValues,
  setSliderValues,
  colors, 
  setColors,
  proVersion,
  classicMode,
  setClassicMode,
  canvasSize,
  setCanvasSize
}) => {
  // const [colors, setColors] = useState(initialColors);
  // const [classic, setClassic] = useState(classicMode);

	const clickRadio = (val) => {
		return (e) => {
			e.preventDefault();
			setCanvasSize(val);
		}
	}

	const CanvasSizePicker = () => {
    if (proVersion) {
      return (
        <form className={style.radioGroup}>
          <label className={style.label}>Download Size</label>
          <Radio className={style.radio} groupName="canvasSize" value={ 1000 } currentValue={ canvasSize } onChange={ clickRadio(1000) } />
          <Radio className={style.radio} groupName="canvasSize" value={ 2000 } currentValue={ canvasSize } onChange={ clickRadio(2000)  } />
          <Radio className={style.radio} groupName="canvasSize" value={ 3000 } currentValue={ canvasSize } onChange={ clickRadio(3000)  } />
          <Radio className={style.radioDesktopOnly} groupName="canvasSize" value={ 4000 } currentValue={ canvasSize } onChange={ clickRadio(4000)  } />
          <p className={style.radioNotice}>4000x4000 isn't available on mobile devices for performance reasons :( Check back on desktop!</p>
        </form>
      )
    } else {
      return (
        <>
        <p>Downloaded image is 1000x1000px</p>
        <p>Want high-res? <a className={style.proButton} href="/pro-version">Go pro!</a></p>
        </>
      )
    }
	}

  const changeSliderValue = (key) => {
    return (v) => {
      const newValues = Object.assign({}, sliderValues);
      newValues[key] = parseFloat(v);
      setSliderValues(newValues)  
    }
  }

  const Sliders = () => {
    const slidersToShow = sliderConfigs.filter((val) => {
			return !val.proVersion || proVersion;
		});

    return slidersToShow.map((config) => {
      const k = config.key;
      const disabled = classicMode && config.proVersion;
      return (
        <SliderInput 
          style={style} 
          disabled={disabled} 
          amount={sliderValues[k]} 
          changeFunc={changeSliderValue} 
          label={config.label} 
          variableKey={k} 
        />
      )
    })
  }

  const ClassicMode = () => {
    if (proVersion) {
      // ugh i guess we're doing css in js now.... 

      const thumbStyle = {
        backgroundImage: 'linear-gradient(#eee 30%, #ccc 70%)',
        height: '1.5em',
        width: '1.5em',
        boxShadow: '0 2px 2px 0 #777',
        borderRadius: 8
      };

      const trackStyle = {
        margin: '1em 0',
        backgroundColor: '#cccccc',
        width: 60
      };
      const labelStyle = {
        fontFamily: "'Space mono', monospace",
        letterSpacing: "0.1em",
        width: 30
      }

      return (
        <div className={style.classicContainer}>
          <label for="classicMode">Classic Mode</label>
          <ToggleButton activeLabelStyle={labelStyle} inactiveLabelStyle={labelStyle} value={classicMode} onToggle={() => setClassicMode(!classicMode)} thumbStyle={thumbStyle} trackStyle={trackStyle} passThroughInputProps={{className: style.toggle}} />
        </div>
      )
    }
  }

  const updateColor = (newColor, index) => {
    const oldColors =  [...colors];
    oldColors[index] = newColor;
    setColors(oldColors);
  }
  const addColor = () => {
    const newColors = colors.concat(['#ffffff']);
    setColors(newColors);
  }
  const removeColor = () => {
    const oldColors = [...colors];
    oldColors.pop();
    setColors(oldColors);    
  }

  return (
    <div className={style.container}>

      <div className={style.colorsContainer}>
        { colors.map((c, i) => (
          <ColorInput key={i} currentColor={c} changeColors={(val) => { updateColor(val, i) }} />
        )) }
      </div>
      <div className={style.buttons}>
        <button disabled={colors.length >= 6} onClick={addColor}>add a color</button>
        <button disabled={colors.length <= 2} onClick={removeColor}>remove a color</button>
      </div>

      { ClassicMode() }

      { Sliders() }

      { CanvasSizePicker() }

      <PasteColors colors={colors} setColors={setColors} style={style} />
    </div>
	);
}


export default Controls;
